// Reads/writes the broker session token, kept under its own localStorage key.
const BROKER_TOKEN_KEY = "brokerToken";

export const brokerSessionStorage = {
    get: () => localStorage.getItem(BROKER_TOKEN_KEY),
    set: (token) => localStorage.setItem(BROKER_TOKEN_KEY, token),
    remove: () => localStorage.removeItem(BROKER_TOKEN_KEY),
};
